import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectPasswordRequirements } from "../features/user/userSlice";
import { getPasswordRequirements } from "../api/userApi";

/**
 * PasswordRequirements Component
 * Displays password requirements fetched from the backend API
 * Falls back to default requirements if API fails
 * 
 * @param {Object} props
 * @param {string} props.className - Additional CSS classes
 * @param {boolean} props.showTitle - Whether to show "Password Requirements" title (default: false for inline use)
 */
const PasswordRequirements = ({ className = "", showTitle = false }) => {
  const dispatch = useDispatch();
  const passwordRequirements = useSelector(selectPasswordRequirements);

  // Default password requirements to show if API fails
  const defaultRequirements = [
    "At least 8 characters",
    "At least one uppercase letter (A-Z)",
    "At least one lowercase letter (a-z)",
    "At least one number (0-9)",
    "At least one special character (!@#$%^&*()_+-=[]{}|;:,.<>?)"
  ];

  useEffect(() => {
    // Fetch password requirements if not already loaded
    if (passwordRequirements.length === 0) {
      dispatch(getPasswordRequirements());
    }
  }, [dispatch, passwordRequirements.length]);

  // Use API requirements if available, otherwise use defaults
  const requirementsToShow = passwordRequirements.length > 0 
    ? passwordRequirements 
    : defaultRequirements;

  return (
    <div className={`password-requirements ${className}`}>
      {showTitle && (
        <p className="text-sm font-semibold text-gray-700 mb-2">
          Password Requirements:
        </p>
      )}
      <ul className="list-disc list-inside space-y-1 text-sm">
        {requirementsToShow.map((requirement, index) => (
          <li key={index} className="text-xs md:text-sm">
            {requirement}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default PasswordRequirements;

